import { AdminPanelType } from '@root-gipro/modules/AdminPanel/interfaces/admin-panel.actions'
import { call, put, takeLatest } from 'redux-saga/effects'
import { fetchData } from '@root-gipro/store/api'
import { showNotify } from '@root-gipro/modules/notify/store/actions'
import {
  setAdminAddModalOA,
  setAdminDeleteModalOA,
  setAdminObjectsAnalogCommon, 
  setDeletedAdminObjectAnalog, 
  updateAdminObjectsAnalog
} from '@root-gipro/modules/AdminPanel/store/actions/actionAdminObjectsAnalog'
import {
  TCreateAdminObjectAnalog,
  TDeleteAdminOA,
  TGetAdminObjectsAnalog
} from '@root-gipro/modules/AdminPanel/interfaces/adminObjectsAnalog'

function* getAdminObjectsAnalog({ 
	params
}: {
	type: AdminPanelType.GET_ADMIN_OBJECTS_ANALOG,
	params: TGetAdminObjectsAnalog
}) {
	try {

		const url = '/analog-objects';

		yield put(setAdminObjectsAnalogCommon({ isObjectsAnalogLoading: true }));
		
		const response: any = yield call(fetchData, url, (res: any) => res);
		
		if(response?.analog_objects) {
			yield put(
				setAdminObjectsAnalogCommon({
					isObjectsAnalogLoading: false,
					objectsAnalog: response?.analog_objects ? response.analog_objects : null,
				})
			)
		}
		
	} catch (error) {
		console.error('Ошибка при загрузке:', error)

		yield put(
			showNotify({
				type: 'error',
				message: `Ошибка при загрузке: ${error}`,
			})
		)
	} finally {
		yield put(setAdminObjectsAnalogCommon({ isObjectsAnalogLoading: false }));
	}
}

function* deleteAdminObjectsAnalog({
	params
}: {
	type: AdminPanelType.DELETE_ADMIN_OA,
	params: TDeleteAdminOA
}) {
	try {

		const url = `/analog-objects/${params.idObjectAnalog}`;

		yield put(setAdminDeleteModalOA({ isDeleting: true }));
		
		const response: any = yield call(fetchData, url, (res: any) => res, 'DELETE');

		if(response.status === 'success') {

			yield put(setDeletedAdminObjectAnalog({
				idObjectAnalog: params.idObjectAnalog,
				status: response.status 
			}));

			yield put(setAdminDeleteModalOA(null));

			yield put(
				showNotify({
					type: 'success',
					message: `Объект-аналог успешно удален`,
				})
			);
		}

	} catch (error) {
		console.error('Ошибка при удалении объекта:', error)

		yield put(
			showNotify({
				type: 'error',
				message: `Ошибка при удалении объекта:${error}`,
			})
		)
	} finally {
		yield put(setAdminDeleteModalOA(null));
	}
}

function* createAdminObjectsAnalog({
  params
}: {
  type: AdminPanelType.CREATE_ADMIN_OA,
  params: TCreateAdminObjectAnalog
}) {
  try {
    
    let statusResponse: number|null = null;
    const data = new FormData();
    
    data.append('name', params.inputs?.name ?? '');
    data.append('th_name', params.inputs?.th_name ?? '');
    data.append('th_count', params.inputs?.th_count ?? '');
    data.append('th_unit', params.inputs?.th_unit ?? '');
    data.append('company_id', params.company_id ?? '');
    
    if(params?.file) {
      data.append('file', params.file, params.inputs?.fileName ?? '');
    }

    const url = `https://${process.env.REACT_APP_ENV}/api/analog-objects/import`;

    yield put(setAdminAddModalOA({ isAdding: true }));

    const response: Response = yield call(() =>
      fetch(url, {
        method: 'POST',
        body: data,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        },
      }).then(res => {
        statusResponse = res?.status;

        return res.json();
      })
    )
    
    // @ts-ignore
    if(response?.analog_objects) {
      yield put(updateAdminObjectsAnalog({
        actionType: 'push',
        // @ts-ignore
        data: response.analog_objects
      }));

      yield put(setAdminAddModalOA(null));

      yield put(
        showNotify({
          type: 'success',
          message: 'Объект-аналог успешно добавлен',
        })
      );
    }
    
    if(statusResponse && statusResponse !== 201) {
      let errorsStr = '';
      
      // @ts-ignore
      if(response?.errors) {
        // @ts-ignore
        Object.values(response.errors).forEach((error: []) => {
          if(error?.length) {
            error.forEach((er) => {
              errorsStr += `${er}`;
            });
          }
        });
      }
      
      // @ts-ignore
      if(!response?.errors && response?.message) {
        // @ts-ignore
        errorsStr = response.message;
      }
      
      yield put(setAdminAddModalOA({ isAdding: false }));
      
      yield put(
        showNotify({
          type: 'error',
          message: `Не удалось добавить объект-аналог. Ошибка: ${errorsStr}`,
        })
      );
    }

  } catch (error) {
    console.error('Ошибка при создании объекта:', error)

    yield put(
      showNotify({
        type: 'error',
        message: `Ошибка при создании объекта:${error}`,
      })
    )
  }
}

export default function* adminPanelObjectsAnalog() {
	yield takeLatest(AdminPanelType.GET_ADMIN_OBJECTS_ANALOG, getAdminObjectsAnalog)
	yield takeLatest(AdminPanelType.DELETE_ADMIN_OA, deleteAdminObjectsAnalog)
	yield takeLatest(AdminPanelType.CREATE_ADMIN_OA, createAdminObjectsAnalog)
}
